export var ThemeBreakpoints;
(function (ThemeBreakpoints) {
    ThemeBreakpoints["SMALL"] = "small";
    ThemeBreakpoints["MEDIUM"] = "medium";
    ThemeBreakpoints["LARGE"] = "large";
    ThemeBreakpoints["MOBILE"] = "mobile";
})(ThemeBreakpoints || (ThemeBreakpoints = {}));
var breakpoints = {
    small: '1366px',
    medium: '1536px',
    large: '1920px',
};
export default breakpoints;
